import type { ShowrooomLayoutVariant } from '@makemydeal/dr-sales-checkin-components';
import { ShowroomLayout } from '@makemydeal/dr-sales-checkin-components';
import { matchPath, useLocation } from 'react-router-dom';
import { routeLayoutConfig } from '../constants';

/**
 * useShowroomLayoutIdentifier
 *
 * Derives the active layout variant from the current route. The chrome
 * (sidebar vs. back button) is a pure function of the URL, so it is resolved
 * from `routeLayoutConfig` rather than stored in redux. Falls back to the
 * sidebar variant when no entry matches.
 */
export const useShowroomLayoutIdentifier = (): ShowrooomLayoutVariant => {
    const { pathname } = useLocation();
    const match = routeLayoutConfig.find((config) => matchPath(pathname, { path: config.path }));

    return match?.layout ?? ShowroomLayout.SIDEBAR;
};
